export default class Sdp {

    constructor(sdp) {
        this.codecs = {};
        this.sdp = sdp;
        //this.lines = [];
        this.sections = {
            'session': [],
            'audio': [],
            'video': []
        }
        this.sectionsOrder = ['session'];
        this.priorities = {
            'audio': [],
            'video': []
        }
        this.bandwidthAdded = false;
        this.parse();
    }

    parse() {
        let lines = this.sdp.split(/\r\n/);
        //Blastream.Log.info(lines);
        let track = 'session';
        for (let i in lines) {
            if (lines[i].startsWith('m=audio')) {
                track = 'audio';
                this.sectionsOrder.push('audio');
                this.setPriorities(lines[i], track);
            }
            if (lines[i].startsWith('m=video')) {
                track = 'video';
                this.sectionsOrder.push('video');
                this.setPriorities(lines[i], track);
            }
            if (lines[i].startsWith('a=rtpmap')) {
                this.addCodec(lines[i], track);
            }
            if (lines[i].indexOf('profile-level-id') > 0) {
                this.addCodecProfile(lines[i]);
            }
            if (lines[i].startsWith('b=AS:') || lines[i].startsWith('b=TIAS:')) {
                this.bandwidthAdded = true;
            }
            this.sections[track].push(lines[i])
        }
        console.log(this.sections);
        console.log(this.priorities);
        console.log(this.codecs)
        //this.lines = lines;
        //Blastream.Log.info(this.codecs);
    }
    
    hasAudio() {
        if(this.priorities.audio.length > 0)
            return true;
        else
            return false;
    }
    
    hasVideo() {
        if(this.priorities.video.length > 0)
            return true;
        else
            return false;
    }

    setPriorities(line, track) {
        const codecIds = line.split(' ');
        for (let i = 0; i < 3; i++)
            codecIds.shift();
        this.priorities[track] = codecIds.shift().split(' ');
    }

    getCodecIdFromLine(line) {
        return line.split(':')[1].split(' ').shift();
    }

    getCodecId(line) {
        const codecId = this.getCodecIdFromLine(line);
        if (!this.codecs[codecId])
            this.codecs[codecId] = {};
        return codecId;
    }
    
    addCodec(line, track) {
        const codecId = this.getCodecId(line);
        const codec = line.split('rtpmap:').pop().split(' ').pop().split('/');
        this.codecs[codecId].name = codec[0].toLowerCase();
        this.codecs[codecId].bitrate = codec[1];
        this.codecs[codecId].kind = track;
    }

    addCodecProfile(line) {
        const codecId = this.getCodecId(line);
        this.codecs[codecId].profileId = line.split('profile-level-id=').pop().split(';').shift();
    }

    haveCodec(codec) {
        codec = codec.toLowerCase();
        for (let i in this.codecs) {
            if (this.codecs[i].name == codec)
                return true;
        }
        return false;
    }

    updateCodecLine(line, goodCodecIds, track) {
        this.priorities[track] = goodCodecIds;
        const codecIds = line.split(' ');
        let res = []
        for (let i = 0; i < 3; i++)
            res.push(codecIds.shift());
        res.push(goodCodecIds.join(' '));
        return res.join(' ');
    }
    
    forceVideoCodec(name) {
        this.forceCodec(name, 'video');
    }
    
    forceAudioCodec(name) {
        this.forceCodec(name, 'audio');
    }
    
    forceCodec(name, track) {
        if (!this.haveCodec(name)) {
            return false;
        }
        
        let codec;
        let codecs = [];
        
        let codecId;
        for (let i in this.sections[track]) {
            if (this.sections[track][i].startsWith('a=rtcp-fb') || this.sections[track][i].startsWith('a=fmtp') || this.sections[track][i].startsWith('a=rtpmap')) {
                codecId = this.getCodecIdFromLine(this.sections[track][i]);
                codec = this.codecs[codecId];
                if(codec) {
                    if (codec.name != name) {
                        delete this.sections[track][i];
                        delete(this.codecs[i]);
                    }
                    else {
                        if(codecs.indexOf(codecId) == -1)
                            codecs.push(codecId);
                    }
                }
                
            }
        }
        this.sections[track] = this.clean(this.sections[track]);
        this.sections[track][0] = this.updateCodecLine(this.sections[track][0], codecs, track);
    }

    forceH264(profileId) {
        if (!this.haveCodec('h264')) {
            return false;
        }
        let codec;
        let goodCodec = false;
        let h264Codecs = [];
        for (let i in this.codecs) {
            codec = this.codecs[i];
            if (codec.kind == 'audio')
                continue;
            if (codec.profileId == profileId) {
                goodCodec = codec;
                h264Codecs.push(i);
            }
        }
        if (!goodCodec) {
            console.warn('h264 profileId not found but still force h264');
        }
        
        let codecId;
        for (let i in this.sections['video']) {
            if (this.sections['video'][i].startsWith('a=rtcp-fb') || this.sections['video'][i].startsWith('a=fmtp') || this.sections['video'][i].startsWith('a=rtpmap')) {
                codecId = this.getCodecIdFromLine(this.sections['video'][i]);
                codec = this.codecs[codecId];
                
                if ((goodCodec && codec.profileId != profileId) || (!goodCodec && codec.name != 'h264')) {
                    delete this.sections['video'][i];
                    delete(this.codecs[i]);
                }
                
                if (!goodCodec && codec.name == 'h264') {
                    if(h264Codecs.indexOf(codecId) == -1)
                        h264Codecs.push(codecId);
                }
                
            }
        }
        this.sections['video'] = this.clean(this.sections['video']);
        this.sections['video'][0] = this.updateCodecLine(this.sections['video'][0], h264Codecs, 'video');
    }

    setBandwith(bitrate, track) {
        const codecId = this.priorities[track][0];
        if (!this.bandwidthAdded) {
            let line;
            let newLines = this.sections[track].slice();
            let index = 0;
            for (let i in this.sections[track]) {
                if (!this.sections[track][i])
                    continue;
                if (this.sections[track][i].startsWith('c=IN')) {
                    line = 'b=AS:' + bitrate;
                    newLines.splice((parseInt(i) + index + 1), 0, line);
                    index++;
                    line = 'b=TIAS:' + (bitrate * 1000);
                    newLines.splice((parseInt(i) + index + 1), 0, line);
                    index++;
                }

                if (this.sections[track][i].startsWith('a=fmtp:' + codecId)) {
                    console.log(i);
                    line = 'a=fmtp:' + codecId + ' x-google-min-bitrate=' + bitrate + ';x-google-max-bitrate=' + bitrate;
                    newLines.splice((parseInt(i) + index + 1), 0, line);
                    index++;
                }
            }
            this.sections[track] = newLines;
            this.bandwidthAdded = true;
        }
        else {
            for (let i in this.sections[track]) {
                if (this.sections[track][i].startsWith('b=AS:')) {
                    this.sections[track][i] = 'b=AS:' + bitrate;
                }
                if (this.sections[track][i].startsWith('b=TIAS:')) {
                    this.sections[track][i] = 'b=TIAS:' + (bitrate * 1000);
                }
                if (this.sections[track][i].startsWith('a=fmtp:' + codecId + ' x-google-min-bitrate=')) {
                    this.sections[track][i] = 'a=fmtp:' + codecId + ' x-google-min-bitrate=' + bitrate + ';x-google-max-bitrate=' + bitrate;
                }
            }
        }
        this.clean(this.sections['video']);
    }

    clean(a) {
        for (let i = 0; i < a.length; i++) {
            if (a[i] == undefined) {
                a.splice(i, 1);
                i--;
            }
        }
        return a;
    };

    getRaw() {
        let res = [];
        //test for ms edge
        /*this.sections['audio'].push('a=end-of-candidates');
        this.sections['video'].pop();
        this.sections['video'].push('a=end-of-candidates');*/
        
        for(let i in this.sectionsOrder) {
            res.push(this.sections[this.sectionsOrder[i]].join("\r\n"));
        }
        return res.join("\r\n");
    }

}


// WEBPACK FOOTER //
// ./src/WebRTC/Sdp.js